<template>
    <div :class="{ 'main-nav': true, disabled: show_active_nav }" id="main-menu" v-if="!is_landing">
        <div
            :class="{
                container: true,
                signup: !is_logged_in,
                'events-list': is_event_menu,
                detail: is_add_view_new
            }"
        >
            <main-navigation-header></main-navigation-header>
            <trial-over
                @close-modal="hide_trial_modal"
                v-if="trial_modal_shown"
                :shown="trial_modal_shown"
            ></trial-over>

            <recurring-edit-modal
                @closed="hide_recurring_modal"
                v-if="recurring_modal_shown"
                :shown="recurring_modal_shown"
            ></recurring-edit-modal>

            <div class="main-nav-title">
                <a
                    v-show="!$route.meta.back_link"
                    @click="$router.go(-1)"
                    href="javascript:{}"
                    class="main-nav-back"
                    v-if="is_add_view_new"
                >
                    <span class="icon-arrow-left"></span>
                </a>
                <a
                    v-show="$route.meta.back_link"
                    @click="$router.push({ path: $route.meta.back_link })"
                    href="javascript:{}"
                    class="main-nav-back"
                    v-if="is_add_view_new"
                >
                    <span class="icon-arrow-left"></span>
                </a>
                {{ view_title }}
                <a v-if="view_meta_link" href="javascript:{}" @click="go_to_link" class="btn btn-primary">+ Add new</a>
                <a
                    v-if="$route.meta.action"
                    @click="handle_function_call($route.meta.action)"
                    :class="{
                        'btn btn-primary': true,
                        disabled: check_view_and_btn_disabled_state,
                        'btn-loader': check_view_and_btn_loading_state
                    }"
                    href="javascript:{}"
                >
                    <div class="loader-line-mask">
                        <div class="loader-line"></div>
                    </div>
                    <span>Save</span></a
                >
                <a
                    @click="close_privacy"
                    v-if="is_privacy_menu && window_length > 1"
                    href="javascript:{}"
                    class="icon-close"
                ></a>
            </div>

            <ul class="main-nav-links" v-if="show_main_nav" v-show="!is_privacy_menu">
                <li :class="{ active: is_event_menu }">
                    <a @click="$router.push({ path: '/events' })" href="javascript:{}">
                        <!--<span class="count">12</span>-->
                        <span class="icon-events"></span>Events</a
                    >
                </li>
                <li :class="{ active: $route.name === 'tasks' }">
                    <a @click="$router.push({ path: '/tasks' })" href="javascript:{}">
                        <span class="icon-tasks"></span>Tasks</a
                    >
                </li>
                <li :class="{ active: $route.name === 'people' }">
                    <a href="javascript:{}" @click="go_to_view('people')"> <span class="icon-people"></span>People</a>
                </li>
                <!--
                    <li>
                        <a href="javascript:{}">
                            <span class="icon-foods"></span>Foods</a>
                    </li>
                    <li>
                        <a href="javascript:{}"><span class="icon-expenses"></span>Expenses</a>
                    </li>
                 -->
            </ul>

            <div class="main-tabs" v-if="is_event_menu">
                <ul>
                    <li @click="change_tab('list')" :class="{ active: active_tab === 'list' }">
                        <a href="javascript:{}">List view</a>
                    </li>
                    <li @click="change_tab('calendar')" :class="{ active: active_tab === 'calendar' }">
                        <a href="javascript:{}">Calendar view</a>
                    </li>
                </ul>
            </div>
            <div class="main-tabs" v-if="is_people_menu">
                <ul>
                    <li @click="change_tab('adults')" :class="{ active: active_people_tab === 'adults' }">
                        <a href="javascript:{}"
                            >Adults<span v-if="adults && adults.length > 0">{{ adults.length }}</span></a
                        >
                    </li>
                    <li @click="change_tab('kids')" :class="{ active: active_people_tab === 'kids' }">
                        <a href="javascript:{}"
                            >Kids<span v-if="kids && kids.length > 0">{{ kids.length }}</span></a
                        >
                    </li>
                </ul>
            </div>

            <privacy-tabs v-if="is_privacy_menu"></privacy-tabs>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import MainNavigationHeader from "@/pages/main-navigation-header.vue";
import TrialOver from "./trial-over-modal.vue";
import PrivacyTabs from "@/pages/page-submenu.vue";
import RecurringEditModal from "@/pages/events/recurring-event-editing-modal.vue";
import router from "@/router";

export default {
    name: "main-navigation",
    data() {
        return {
            window_length: window.history.length,
            trial_modal_shown: false,
            recurring_modal_shown: false
        };
    },
    components: { MainNavigationHeader, PrivacyTabs, TrialOver, RecurringEditModal },
    created() {},
    computed: {
        ...mapState("StoreEvent", [
            "active_tab",
            "save_btn_disabled",
            "event",
            "active_event",
            "event_adding_error",
            "errors",
            "save_btn_loading"
        ]),
        ...mapState("StorePeople", [
            "active_people_tab",
            "person",
            "person_save_btn_disabled",
            "person_save_btn_loading"
        ]),
        ...mapState("StoreTask", ["task", "task_event_save_btn_disabled", "task_event_save_btn_loading"]),
        ...mapGetters("StorePeople", ["adults", "kids"]),
        ...mapState(["is_logged_in", "user"]),
        is_event_menu() {
            return this.$route.name === "events";
        },
        is_people_menu() {
            return this.$route.name === "people";
        },
        is_landing() {
            return this.$route.name === "landing";
        },
        is_privacy_menu() {
            return this.$route.name === "privacy";
        },
        show_main_nav() {
            return !this.$route.meta.isAddView;
        },
        is_add_view_new() {
            return this.$route.meta.isAddView;
        },
        check_view_and_btn_disabled_state() {
            if (this.$route.name === "people-add") {
                return this.person_save_btn_disabled;
            }
            if (this.$route.name === "tasks-add") {
                return this.task_event_save_btn_disabled;
            } else {
                return this.save_btn_disabled;
            }
        },
        check_view_and_btn_loading_state() {
            if (this.$route.name === "people-add") {
                return this.person_save_btn_loading;
            }
            if (this.$route.name === "tasks-add") {
                return this.task_event_save_btn_loading;
            } else {
                return this.save_btn_loading;
            }
        },
        show_active_nav() {
            return ["signup", "login", "forgot-password"].includes(this.$route.name);
        },
        view_meta_link() {
            return this.$route.meta.addNewLink;
        },
        view_title() {
            return this.$route.meta.title;
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.get_logged_in_user();
        });
    },
    mounted() {
        this.get_logged_in_user();
    },
    methods: {
        ...mapActions("StoreEvent", ["save_event", "get_calendar_events", "set_tab"]),
        ...mapActions("StorePeople", ["save_person"]),
        ...mapActions(["get_logged_in_user"]),
        ...mapActions("StoreTask", ["save_event_task"]),
        ...mapMutations("StoreEvent", ["set_btn_loading"]),
        ...mapMutations("StoreTask", ["set_btn_loading"]),
        ...mapMutations("StorePeople", ["set_people_tab", "set_person_btn_loading"]),

        handle_function_call(function_name) {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                this[function_name]();
            } else {
                this.trial_modal_shown = true;
            }
        },
        check_time_format(time_format) {
            return /^\d{2}:\d{2}$/.test(time_format);
        },
        hide_trial_modal() {
            this.trial_modal_shown = false;
        },
        hide_recurring_modal() {
            this.recurring_modal_shown = false;
        },

        go_to_view(path_name) {
            router.push({ path: "/" + path_name });
        },
        change_tab(tab) {
            if (this.is_event_menu) {
                this.set_tab(tab);
            }
            if (this.is_people_menu) {
                this.set_people_tab(tab);
            }
        },
        save_new_event() {
            if (this.event.recurring && this.event.id) {
                this.recurring_modal_shown = true;
            } else {
                this.set_btn_loading(true);
                this.save_event(this.event);
            }
        },
        save_task() {
            this.set_btn_loading(true);
            this.save_event_task(this.task);
        },
        close_privacy() {
            router.go(-1);
        },
        go_to_link() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                window.location = this.view_meta_link;
            } else {
                this.trial_modal_shown = true;
            }
        },
        save_new_person() {
            let person = { ...this.person };
            this.save_person(person);
        }
    }
};
</script>

<style scoped>
.icon-close {
    margin-left: auto;
    margin-top: 0.6rem;
}
</style>
